/**
 * 园区收入明细 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例

// 接口请求地址
const api = '/c-api/parkmoneylog/'

const parkmoneylog = {
  // 列表
  list(params) {
    return axios.get(api + 'list', { params: params })
  },
  detail(params) {
    return axios.get(api + 'detail', { params: params })
  },
  ordermoney(params) {
    return axios.get(api + 'ordermoney', { params: params })
  },
  todaymoney(params) {
    return axios.get(api + 'todaymoney', { params: params })
  },
  parktxlist(params) {
    return axios.get(api + 'parktxlist', { params: params })
  },
}

// 导出接口
export default parkmoneylog
